import { useTranslation } from 'react-i18next'
import { useModalOpened, useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import Modal from '~/components/Modal'
import { useHelpCenterUrl } from '~/hooks'
import Button from '~/components/Button'
import {
  Container,
  StyledIcon,
  StyledTitle,
  StyledDesc,
  StyledLearnMore,
} from './styled'
import IconGreenShield from '~/assets/images/greenShield.svg'

const SwapProtectionIntroModal = () => {
  const { t } = useTranslation()

  const toggle = useModalToggle(ApplicationModal.SWAP_PROTECTION_INTRO)
  const isOpen = useModalOpened(ApplicationModal.SWAP_PROTECTION_INTRO)
  const helpCenterUrl = useHelpCenterUrl('20588637587220')

  return (
    <Modal
      animate={false}
      isOpen={isOpen}
      onDismiss={toggle}
      contentClassName="new-modal-base-content"
    >
      <Container>
        <StyledIcon src={IconGreenShield} alt="greenShield" />
        <StyledTitle>{t('swap_protection_title')}</StyledTitle>
        <StyledDesc>
          <span>{t('swap_protection_desc')}</span>
          <StyledLearnMore href={helpCenterUrl} target="_blank">{` ${t(
            'learn_more',
          )} >`}</StyledLearnMore>
        </StyledDesc>
        <Button handleClick={toggle} text={t('ok')} />
      </Container>
    </Modal>
  )
}

export default SwapProtectionIntroModal
